import { render } from "./OrderBevestigingDetailTab.vue?vue&type=template&id=b6f7f39c&scoped=true"
import script from "./OrderBevestigingDetailTab.vue?vue&type=script&lang=js"
export * from "./OrderBevestigingDetailTab.vue?vue&type=script&lang=js"

import "./OrderBevestigingDetailTab.vue?vue&type=style&index=0&id=b6f7f39c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6f7f39c"]])

export default __exports__